export enum LiveFeedPinUnpin {
  PIN = 0,
  UNPIN = 1,
}
